"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateOut = void 0;
class TemplateOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return TemplateOut.attributeTypeMap;
    }
}
exports.TemplateOut = TemplateOut;
TemplateOut.discriminator = undefined;
TemplateOut.attributeTypeMap = [
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "filterTypes",
        "baseName": "filterTypes",
        "type": "Array<string>",
        "format": ""
    },
    {
        "name": "id",
        "baseName": "id",
        "type": "string",
        "format": ""
    },
    {
        "name": "instructions",
        "baseName": "instructions",
        "type": "string",
        "format": ""
    },
    {
        "name": "instructionsLink",
        "baseName": "instructionsLink",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "kind",
        "baseName": "kind",
        "type": "TransformationTemplateKind",
        "format": ""
    },
    {
        "name": "logo",
        "baseName": "logo",
        "type": "URI",
        "format": "uri"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "orgId",
        "baseName": "orgId",
        "type": "string",
        "format": ""
    },
    {
        "name": "transformation",
        "baseName": "transformation",
        "type": "string",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=TemplateOut.js.map